import { apiFetch } from "@/utils";

function initMapParams() {
    return apiFetch("maps/maps-parameters")
    .then((response) => {
      var styleRegion = response.find(e => e.Scope == "Region");
      var styleDepartement = response.find(e => e.Scope == "Departement");
      var styleDepartementAdvs = response.find(e => e.Scope == "DepartementAdvs");
      var styleStat1 = response.find(e => e.Scope == "ColorStat1")
      var styleStat2 = response.find(e => e.Scope == "ColorStat2")
      var styleStat3 = response.find(e => e.Scope == "ColorStat3")
      var styleStat4 = response.find(e => e.Scope == "ColorStat4")
      var seuil1 = response.find(e => e.Scope == "pdmSeuil1")
      var seuil2 = response.find(e => e.Scope == "pdmSeuil2")
      var seuil3 = response.find(e => e.Scope == "pdmSeuil3")


      const res = {
        departement: {
          color: styleDepartement.Color,
          fillcolor: styleDepartement.InnerColor
        },
        region: {
          color: styleRegion.Color,
          fillcolor: styleRegion.InnerColor
        },
        departementAdvs: {
          color: styleDepartementAdvs.Color,
          fillcolor: styleDepartementAdvs.InnerColor
        },
        stats: {
          colorStat1: styleStat1.Color,
          fillcolorStat1: styleStat1.InnerColor,
          colorStat2: styleStat2.Color,
          fillcolorStat2: styleStat2.InnerColor,
          colorStat3: styleStat3.Color,
          fillcolorStat3: styleStat3.InnerColor,
          colorStat4: styleStat4.Color,
          fillcolorStat4: styleStat4.InnerColor,
          statSeuil1: seuil1.Color,
          statSeuil2: seuil2.Color,
          statSeuil3: seuil3.Color
        }
      };

      return res;
    })
    .catch(error => {
      console.log(error);
    });
}

function initAdherentParams() {
  return new Promise((resolve) => {
    let p1 = apiFetch("maps/adherents/parameters");
    let p2 = apiFetch("maps/adherents/parameters/exclusion");
    Promise.all([p1, p2]).then(([res1, res2]) => {
      resolve({ adherentParams: res1, adhExclusions: res2.adhExclusions, allAdh: res2.allAdh });
    })
  })
}

function initTrancheCa() {
  return apiFetch("maps/trancheCa").then((response) => {
    return response;
  })
}

function initVisibilityFilters() {
  return apiFetch("maps/filters")
    .then((response) => {
      return response;
    })
    .catch(error => {
      console.log(error);
    });
}

function initParameters() {
  return apiFetch("maps/parameters")
    .then((response) => {
      return response;
    })
    .catch(error => {
      console.log(error);
    });
}

export default {
  initMapParams,
  initAdherentParams,
  initTrancheCa,
  initVisibilityFilters,
  initParameters
}

export {
  initMapParams,
  initAdherentParams,
  initTrancheCa,
  initVisibilityFilters,
  initParameters
}



// WEBPACK FOOTER //
// ./src/utils/adminMapsMixin.js